/* eslint-disable jira/filename-case */
let eventDelayActive = false;

export const setEventDelayActive = (isEventDelayActive: boolean): void => {
	eventDelayActive = isEventDelayActive;
};

export const isEventDelayActive = (): boolean => eventDelayActive;
